import {
  Layout,
  Button,
  Input,
  message,
  Table,
  ConfigProvider,
  Tabs,
  Row,
  Col,
  Popconfirm,
  Statistic,
  Pagination,
  Select,
  Popover,
} from 'antd'
import { Content } from 'antd/lib/layout/layout'
import zhCN from 'antd/lib/locale/zh_CN'
import OAMSider from '../oam-sider'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'

import idataCourseTableStyles from '../../common/global-styles/idatacourse-table.module.less'
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../../constants/constants'
import UserCard from '../user/oam-userinfo-card'

const { Search } = Input

export interface Props {}


/** OAM 社区文章列表页 */
export const OAMPostList: React.FC<Props> = (props) => {
  const [postResult, setPostResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [totalCount, setTotalCount] = useState(0) // 总文章
  const [recommendCount, setRecommendCount] = useState(0) // 已推荐文章

  const queryContent = useRef('') // 记录搜索串
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量

  const statusFilters = useRef([]) // 状态过滤选项

  useEffect(() => {
    queryPostList()
  }, [])

  /**
   * 查询文章列表
   */
  const queryPostList = () => {
    sendHttpPostRequest(
      'community/api/oam_query_post_list/',
      {
        sessionid: Cookies.get('sessionid'),
        query: queryContent.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: order_by.current,
        on_top: JSON.stringify(statusFilters.current),
      },
      queryPostListCallback
    )
  }

  /**
   * 查询文章列表回调
   * @param response
   */
  const queryPostListCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_post_list'
    } else if (response.code == 0) {
      // 成功
      setPostResult(response.query_list)
      setResultSum(response.total_sum)
      setTotalCount(response.total_count)
      setRecommendCount(response.recommend_count)

    } else if (response.code == -501) {
      // 权限不足
      window.location.href = '/oam_login?next=oam_post_list'
    } else {
      message.error(response.message)
    }
  }




  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryPostList()
  }



  // 点击 删除
  const onDeleteBtnClick = (postId: string) => {
    sendHttpPostRequest(
      'community/api/oam_delete_post_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: postId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == -501) {
          // 没权限
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == 0) {
          queryPostList()
        } else {
          message.error(response.message)
        }
      }
    )
  }


  // 点击 取消推荐
  const onUnRecommendBtnClick = (postId: string) => {
    sendHttpPostRequest(
      'community/api/oam_unrecommend_post_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: postId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == -501) {
          // 没权限
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == 0) {
          queryPostList()
        } else {
          message.error(response.message)
        }
      }
    )
  }

   // 点击 推荐
   const onRecommendBtnClick = (postId: string) => {
    sendHttpPostRequest(
      'community/api/oam_recommend_post_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: postId,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == -501) {
          // 没权限
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == 0) {
          queryPostList()
        } else {
          message.error(response.message)
        }
      }
    )
  }

  


  // 渲染操作
  const renderActions = (text: any, record: any) => {
      return (
        <Row
          justify="center"
          align="middle"
          style={{ gap: '10px' }}
          wrap={false}
        >
          <Col>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="editit"
              onClick={() => {
                window.open('/community-article-detail?id=' + record.id)
              }}
            >
              {' '}
              查看
            </Button>
          </Col>
          <Col>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="editit"
              type="dashed"
              onClick={() => {
                window.open('/oam-post-edit?post_id=' + record.id)
              }}
            >
              {' '}
              编辑
            </Button>
          </Col>
            <Col>
              {' '}
              {record.on_top == 1 ? (
                <Button
                  style={{ borderRadius: 20, fontSize: 12 }}
                  size="small"
                  id="puton"
                  value={record.id}
                  type="primary"
                  onClick={onRecommendBtnClick.bind(
                    this,
                    record.id,
                  )}
                >
                  {' '}
                  推荐{' '}
                </Button>
              ) : (
                <Popconfirm
                  placement="top"
                  title={'确认取消推荐 "' + record.title + '" 吗？'}
                  onConfirm={onUnRecommendBtnClick.bind(
                    this,
                    record.id,
                  )}
                  okText="确认"
                  cancelText="取消"
                >
                  <Button
                    style={{ borderRadius: 20, fontSize: 12 }}
                    size="small"
                    id="putoff"
                    value={record.id}
                    type="primary"
                    danger
                  >
                    {' '}
                    取消{' '}
                  </Button>
                </Popconfirm>
              )}
            </Col>
          
            <Col>
              <Popconfirm
                placement="top"
                title={'确认删除文章 "' + record.title + '" 吗？'}
                onConfirm={onDeleteBtnClick.bind(this, record.id)}
                okText="确认"
                cancelText="取消"
              >
                <Button
                  style={{ borderRadius: 20, fontSize: 14 }}
                  size="small"
                  type="dashed"
                  danger
                >
                  {' '}
                  删除
                </Button>
              </Popconfirm>
            </Col>
        
        </Row>
      )

  }

 

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryPostList()
  }

  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      order_by.current = sorter.field
    }
    if (filters.on_top) {
      statusFilters.current = filters.on_top;
  } else {
      statusFilters.current = [];
  }

    page.current = 1
    queryPostList()
  }

  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      width: 100,
      ellipsis: true,
    },
    {
      title: '标题',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      align: 'left',
      width: 200,
      render: (t, r, i) => (
        <span
          className={GlobalCss.link}
          onClick={() =>
            window.open('/community-article-detail?id=' + r.id)
          }
        >
          {t}
        </span>
      ),

    },
    {
      title: '点赞数',
      dataIndex: 'praised_count',
      key: 'praised_count',
      align: 'center',
      width: 80,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '浏览数',
      dataIndex: 'view_count',
      key: 'view_count',
      align: 'center',
      width: 80,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '回复数',
      dataIndex: 'reply_count',
      key: 'reply_count',
      align: 'center',
      width: 80,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      align: 'left',
      width: 150,
      ellipsis: true,
      render: (text: any, record: any) =>
      {
          return (
            <Row align="middle" justify="start" wrap={false}>
              <Col flex="40px">
                <Popover
                  arrowPointAtCenter={true}
                  trigger="hover"
                  placement="left"
                  content={<UserCard user_id={record?.creator_id} />}
                  title={null}
                >
                  <img
                    onMouseOver={() => {}}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 15,
                      cursor: 'pointer',
                    }}
                    src={record?.creator_avatar?.startsWith('http') ? record?.creator_avatar : BACKEND_API_URL + record?.creator_avatar}
                  />
                </Popover>
              </Col>
              <Col flex="80px">
                <span>{record.creator_real_name == '' ? record.creator_name : record.creator_real_name}</span>
              </Col>
            </Row>
          )   
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 180,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '状态',
      dataIndex: 'on_top',
      key: 'on_top',
      align: 'center',
      width: 80,
      ellipsis: true,
      render: (t, r, i) => {
        if (t == 1){
          return '未推荐'

        }else {
          return '已推荐'
        }

      },
      filters: [
        {
            text: '未推荐',
            value: 1,
        },
        {
            text: '已推荐',
            value: 2,
        }
    ],
    onFilter: (value:any, record:any) => true,
    },
    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 280,
      ellipsis: true,
      align: 'center',
      fixed: 'right',
      render: renderActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh',minWidth:1200 }}>
      <OAMSider keys={['888']} openKeys={[]} />
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 30 }}>
            <Row align="middle" gutter={16} style={{marginBottom:10}}>
              <Col flex="80px">
                <Statistic title="总文章" value={totalCount} />
              </Col>
              <Col flex="80px">
                <Statistic title="已推荐" value={recommendCount} />
              </Col>

              <Col flex="350px">
                <Search
                  placeholder="搜索文章"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                  className={idataCourseTableStyles.oamSearch}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: 'right' }}>
              </Col>
            </Row>

            <div style={{minHeight: 500}}  className={idataCourseTableStyles.tableWrapper}>
              <ConfigProvider locale={zhCN}>
                <Table
                  dataSource={postResult}
                  columns={columns}
                  rowKey={(record) => record.id}
                  pagination={false}
                  scroll={{ x: 800 }}
                  onChange={onTableChange}
                />
              </ConfigProvider>
            </div>


            <ConfigProvider locale={zhCN}>
              <div
                style={{ marginBottom: 30,}}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  defaultPageSize={10}
                  current={page.current}
                  hideOnSinglePage={true}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showSizeChanger={false}
                  showTotal={(total) => `共 ${total} 文章`}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default OAMPostList
